import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';

const Dashboard = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const fetchJobs = async () => {
    try {
      const res = await axios.get('http://localhost:5000/api/job/');
      setJobs(res.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching jobs:', error);
      setLoading(false);
    }
  };

  const fetchJobById = async () => {
    const jobId = prompt('Enter Job ID');
    if (!jobId) return;
    try {
      const res = await axios.get(`http://localhost:5000/api/job/${jobId}`);
      alert(`Job Title: ${res.data.title}`);
    } catch (error) {
      alert('Job not found');
    }
  };

  const deleteJob = async () => {
    const jobId = prompt('Enter Job ID to delete');
    if (!jobId) return;
    try {
      await axios.delete(`http://localhost:5000/api/job/${jobId}`);
      alert('Job deleted successfully');
      fetchJobs(); // refresh list
    } catch (error) {
      alert('Failed to delete job');
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 px-4 py-8">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
        <h2 className="text-3xl font-bold text-gray-800">Welcome, Admin</h2>
        <button
          onClick={handleLogout}
          className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition"
        >
          Logout
        </button>
      </div>

      {/* Actions */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <button
          onClick={() => navigate('/admin/create')}
          className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition"
        >
          Create Job
        </button>
        <button
          onClick={() => navigate('/admin/update')}
          className="bg-yellow-500 text-white px-4 py-2 rounded-md hover:bg-yellow-600 transition"
        >
          Update Job
        </button>
        <button
          onClick={fetchJobs}
          className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition"
        >
          Get All Jobs
        </button>
        <button
          onClick={fetchJobById}
          className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition"
        >
          Get Job By ID
        </button>
        <button
          onClick={deleteJob}
          className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 transition col-span-1 sm:col-span-2 md:col-span-4"
        >
          Delete Job
        </button>
      </div>

      {/* Job Listings */}
      <h3 className="text-xl font-semibold text-gray-700 mb-4">All Jobs</h3>
      {loading ? (
        <div className="text-center text-gray-600">Loading jobs...</div>
      ) : jobs.length === 0 ? (
        <div className="text-center text-gray-500">No jobs available</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {jobs.map((job) => (
            <div
              key={job._id}
              className="bg-white shadow-md rounded-xl overflow-hidden p-4 hover:shadow-lg transition"
            >
              {job.image && (
                <img
                  src={`http://localhost:5000/uploads/${job.image}`}
                  alt="job"
                  className="w-full h-40 object-cover rounded-md mb-4"
                />
              )}
              <h4 className="text-lg font-bold text-gray-800 mb-1">{job.title}</h4>
              <p className="text-gray-600 text-sm mb-2">{job.paragraph}</p>
              <p className="text-gray-500 text-sm">
                <span className="font-medium">Location:</span> {job.location || 'N/A'}
              </p>
              <p className="text-gray-500 text-sm">
                <span className="font-medium">Salary:</span> ₹{job.salary || 0}
              </p>
              <p
                className={`text-sm mt-2 ${
                  job.isActive ? 'text-green-600' : 'text-red-500'
                }`}
              >
                Status: {job.isActive ? 'Active' : 'Inactive'}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dashboard;
